import { checkCheckboxes, uncheckCheckboxes } from '../../components/checkbox'
import { initEmailStatusModal } from '../../components/email_status'

function initInboxList() {
  const buttonSelectAll = document.getElementById(
    'btn-select-all',
  ) as HTMLButtonElement
  const buttonSelectNone = document.getElementById(
    'btn-select-none',
  ) as HTMLButtonElement
  const buttonSelectRead = document.getElementById(
    'btn-select-read',
  ) as HTMLButtonElement
  const buttonSelectUnread = document.getElementById(
    'btn-select-unread',
  ) as HTMLButtonElement
  const allCheckboxes = document.getElementsByName(
    'email',
  ) as NodeListOf<HTMLInputElement>

  function enableDisableActions() {
    const anyChecked = Array.from(allCheckboxes, ({ checked }) => checked).some(
      (e) => e,
    )
    for (const actionButton of document.querySelectorAll<HTMLButtonElement>(
      'button.inbox-action',
    )) {
      actionButton.disabled = !anyChecked
    }
  }

  buttonSelectAll.addEventListener('click', () => {
    checkCheckboxes(allCheckboxes)
    enableDisableActions()
  })

  buttonSelectNone.addEventListener('click', () => {
    uncheckCheckboxes(allCheckboxes)
    enableDisableActions()
  })

  buttonSelectRead.addEventListener('click', () => {
    uncheckCheckboxes(allCheckboxes)

    const readCheckboxes = document.querySelectorAll(
      'tr.email-entry div:not(.unread) input.form-check-input',
    ) as NodeListOf<HTMLInputElement>
    checkCheckboxes(readCheckboxes)

    enableDisableActions()
  })

  buttonSelectUnread.addEventListener('click', () => {
    uncheckCheckboxes(allCheckboxes)

    const unreadCheckboxes = document.querySelectorAll(
      'tr.email-entry div.unread input.form-check-input',
    ) as NodeListOf<HTMLInputElement>
    checkCheckboxes(unreadCheckboxes)

    enableDisableActions()
  })

  for (const checkbox of allCheckboxes) {
    checkbox.addEventListener('click', () => {
      enableDisableActions()
    })
  }
  initEmailStatusModal()
}
export { initInboxList }
